'use strict';
import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Subscriptions = {

    async create(paymentMethod, email, plan, planID, firebaseID) {
        try {
            if (!paymentMethod || !email || !plan || !planID|| !firebaseID) {
                return { error: "A mandatory field is missing" }
            }

            let response = await axios.post(API_URL + '/createSubscription/' + firebaseID, {
                "payment_method": paymentMethod,
                "email": email,
                "plan": plan.toString(),
                "planId": parseInt(planID)
            });

            return response.data;

        } catch (error) {
            return false;
        }
    },

    // Create a subscription
    async createUserSubscription(firebaseID, planID) {
        try {
            if (!planID || !firebaseID) {
                return { error: "A mandatory field is missing"};
            }

            planID = parseInt(planID);

            let response = await axios.post(API_URL + '/createUserSubscription/' + firebaseID, {
                planId: planID
            });

            if (!response.data.user_id) {
                return false;
            }
            
            return true;

        } catch(error) {
            return { error: error.response.data.message };
        }
    },

    async update(subscriptionID, planID, plan, upgrading) {
        try {
            if (!subscriptionID || !planID) {
                return { error: 'At least one field is missing' };
            }

            let header = await getHeader();
        
            let response = await axios.post(API_URL + '/payments/changeSubscription', {
                "subscription": subscriptionID,
                "planId": parseInt(planID),
                "plan": plan,
                "upgrade": upgrading
            }, header);
            
            if (response.data.user_id) {
                return true;
            }

            return false;

        } catch (error) {
            return false;
        }
    },

    async cancel() {
        try {
            let response = await axios.delete(API_URL + '/cancelSubscription', await getHeader());
            
            if (response.data.message.includes('Successfully cancelled the subscription')) {
                return true;
            }

            return false;

        } catch (error) {
            return false;
        }
    }
    
}

export default Subscriptions;